export default class {
    constructor (MomentService) {
        this.MomentService = MomentService;
    }

    convertFromToFilterFields (from, to) {
        const fromString = from ? this.MomentService.formatDate(from) : '...';
        const toString = to ? this.MomentService.formatDate(to) : '...';
        return `${fromString} - ${toString}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/filterOverview/index.js